<template>
  <div style="display: inline;">
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/basic/material/regular/capacity/page" getKey="rows" :columns="columns">
      <!-- 左侧按钮插槽 -->
      <template #buttonsL="scope">
        <el-button size="mini" @click="yt.showEditDialog('xinzeng',null,'w1');" type="primary">
          {{$t('xinzeng')}}
        </el-button>
      </template>
      <!-- 操作插槽 -->
      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1">
            <el-button type="text" @click="yt.showEditDialog('bianji', scope.row)">{{$t('bianji')}}
            </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button type="text" :loading="yt.editObj.loading" class="font-color-danger"
                       @click="yt.remove(scope.row,'/web/basic/material/regular/capacity/delete')">{{$t('shanchu')}}
            </el-button>
          </el-col>
        </el-row>
      </template>
    </yi_curd_table>

    <!-- 新增/编辑弹框 -->
    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog"
               :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
      <!-- 新增表单 -->
      <template v-if="yt.editObj.action == 'xinzeng' || yt.editObj.action == 'bianji'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item  :label="$t('shebeidunwei')" required>
            <el-input-number v-model="yt.editObj.equipmentTonnage" :min="1" step-strictly oninput="value=value.replace(/^0|[^0-9]/g, '')" controls-position="right"></el-input-number>
          </el-form-item>
          <el-form-item  :label="$t('guidingchanneng')" required>
            <el-input-number v-model="yt.editObj.regularCapacity" :min="1" step-strictly oninput="value=value.replace(/^0|[^0-9]/g, '')" controls-position="right"></el-input-number>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
					<el-button size="mini" @click="yt.isShowEditDialog = false">{{$t('quxiao')}}</el-button>
					<el-button size="mini" :loading="yt.editObj.loading" @click="yt.req('POST','/web/basic/material/regular/capacity/create',beforeAdd)"
                     type="primary" v-if="yt.editObj.action == 'xinzeng'">
						{{$t('baocun')}}
					</el-button>
          <el-button size="mini" :loading="yt.editObj.loading" @click="yt.req('POST','/web/basic/material/regular/capacity/update',beforeAdd)"
                     type="primary" v-if="yt.editObj.action == 'bianji'">
						{{$t('baocun')}}
					</el-button>
				</span>
      </template>
    </el-dialog>
  </div>
</template>
<script type="text/javascript">
export default {
  name: 'web_base_matter_regular_capacity',
  data() {
    return {
      columns: [{
        label: 'shebeidunwei',
        prop: 'equipmentTonnage',
      }, {
        label: 'guidingchanneng',
        prop: 'regularCapacity',
      }, {
        label: 'chuangjianshijian',
        prop: 'createTime',
        type: 'time',
      },{
        label: 'chuangjianren',
        prop: 'createByObject.nickname',
      }, {
        label: 'caozuo',
        type: 'slot',
        fixed: 'right',
        width: 120
      }]
    }
  },
  created() {
    setTimeout(() => {
      this.yt.conditions = {
        materialId: this.$attrs.material.id
      }
      this.yt.get(1);
    }, 300)

  },
  methods: {
    beforeAdd(params, url) {
      params.materialId = this.$attrs.material.id;
      return params;
    },
  }
}
</script>

<style lang="scss">

</style>